import type { AxiosInstance } from 'axios';
import {
	downloadFileQuery,
	useAxiosInstance,
	useDownloadPoMutation,
} from '@gov-nx/api';
import { useDownloadEvents, useMessageEvents } from '@gov-nx/core/events';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import type { DownloadCallback } from '../Download/types';

export const DownloadFileListener = () => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Service);
	const { toastMessageSuccess, toastMessageError } = useMessageEvents();
	const { download } = useDownloadEvents();
	const { axiosInstance } = useAxiosInstance();

	const downloadMutation = useDownloadPoMutation<{
		id: string;
		axiosInstance: AxiosInstance;
		callback: DownloadCallback<string>['callback'];
	}>(downloadFileQuery, {
		onError: (error, variables) => {
			errorMessage();
			if (variables.callback) {
				variables.callback(variables.id, null, error);
			}
		},
		onSuccess: (data) =>
			download({
				blob: data.blob,
				fileName: data.fileName,
				antivirus: data.antivirus,
				id: data.variables.id,
				callback: (id, success, error) => {
					if (success) {
						successMessage(data.fileName);
						if (data.variables.callback) {
							data.variables.callback(id, true, null);
						}
					}
					if (error) {
						errorMessage();
						if (data.variables.callback) {
							data.variables.callback(id, null, error);
						}
					}
				},
			}),
	});

	useDownloadEvents({
		onFileDownload: (_, { id, callback }) =>
			downloadMutation.mutate({ id, callback, axiosInstance }),
	});

	const successMessage = (fileName: string) => {
		toastMessageSuccess(
			t('soubor.stazeni-souboru-uspech', {
				fileName,
			})
		);
	};

	const errorMessage = () => {
		toastMessageError(t('soubor.stazeni-souboru-chyba'));
	};

	return null;
};
